import { render, staticRenderFns } from "./ClientProfile.vue?vue&type=template&id=b98f41d8&scoped=true"
import script from "./ClientProfile.vue?vue&type=script&lang=js"
export * from "./ClientProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98f41d8",
  null
  
)

export default component.exports